import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { searchCentralClients } from '../../modules/clients/actions';
import ClientSearchModal from './ClientSearchModal';
import styles from './ClientSearchModal.styles';
import { getUngroupedClients, getRecentClients } from '../../modules/clients/selectors';

const mapStateToProps = ({ clientsModule }) => {
  return {
    clientList: getUngroupedClients(clientsModule),
    recentSearchList: getRecentClients(clientsModule),
    loading: clientsModule.clientsList.loading || clientsModule.clientsRecentList.loading,
    hasMore: clientsModule.clientsList.hasMore,
    showAddProfileButton: clientsModule.clientsList.showAddProfileButton,
  };
};

const mapDispatchToProps = {
  searchCentralClients,
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ClientSearchModal);
